import { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import DoctorMedicalMappingController from "../../controller/DoctorMedicalCenterMappingController";
import DepartmentController from "../../controller/DepartmentController";
import SubDepartmentController from "../../controller/SubDepartmentController";
import DoctorDepartmentController from "../../controller/DoctorDepartmentController.jsx";
import MedicalCenterController from "../../controller/MedicalCenterController";
import ServiceController from "../../controller/ServiceController";
import DoctorController from "../../controller/DoctorController";
import DoctorAssociateController from "../../controller/DoctorAssociateController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    FormControlLabel,
    Radio,
    Stack,
    Checkbox,
    TextField,
    FormGroup,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
    doctorId: "",
    doctorDepartmentId: "",
    subDepartmentId: "",
    serviceId: "",
    // wef: "",
    // doctorStatus: "",
};

const FORM_VALIDATION = Yup.object().shape({
    doctorId: Yup.string()
        .trim()
        .required("Doctor is required"),
    departmentId: Yup.string()
        .trim()
        .required("Doctor Department is required"),
    subDepartmentId: Yup.string()
        .trim()
        .required("Doctor Sub-department is required"),
    serviceId: Yup.string()
        .trim()
        .required("Doctor Service is required"),
    // wef: Yup.string()
    //     .trim()
    //     .required("WEF is required"),
    // doctorStatus: Yup.string()
    //     .trim()
    //     .required("Department Status is required"),

});

let requestType = "";
const DoctorDepartment = () => {
    const doctorDepartmentController = new DoctorDepartmentController();
    const medicalCenterController = new MedicalCenterController();
    const doctorController = new DoctorController();

    const departmentController = new DepartmentController();
    const subDepartmentController = new SubDepartmentController();
    const serviceController = new ServiceController();
    // const doctorAssociateController = new DoctorAssociateController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [doctorOptions, setDoctorOptions] = useState();
    const [departmentOptions, setDepartmentOptions] = useState();
    const [departmentId, setDepartmentId] = useState('');
    const [subDepartmentOptions, setSubDepartmentOptions] = useState();
    const [serviceOptions, setServiceOptions] = useState();
    const [doctorDepartment, setDoctorDepartment] = useState([]);
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allDocData, setAllDocData] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllDoctorDepartment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllDoctor = async () => {
        let caughtError;
        try {
            const response = await doctorController.GetAllDoctor(token);
            if (response.status === 200) {
                const doctorData = response?.data?.body?.map((item) => ({
                    // ...item,
                    doctorName: item.doctorName,
                    doctorId: item._id,
                }));
                setDoctorOptions(doctorData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctor",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDepartment = async () => {
        let caughtError;
        try {
            const response = await departmentController.GetDepartmentOptions(token);
            if (response.status === 200) {
                const departmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    departmentName: item.departmentName,
                    departmentId: item._id,
                }));
                setDepartmentOptions(departmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDepartment in DoctorDepartment page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getSubDepartment = async (departmentId) => {
        let caughtError;
        try {
            const response = await subDepartmentController.GetSubDepartmentById(departmentId, token);
            if (response.status === 200) {
                const subDepartmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    subDepartmentName: item.subDepartmentName,
                    subDepartmentId: item._id,
                }));
                setSubDepartmentOptions(subDepartmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getSubDepartment in DoctorDepartment Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllServicesByDepartmentId = async (departmentId) => {
        let caughtError;
        try {
            const response = await serviceController.GetAllServiceByDepartment(departmentId, token);
            if (response.status === 200) {
                const serviceData = response?.data?.body?.map((item) => ({
                    // ...item,
                    serviceName: item.serviceName,
                    serviceId: item._id,
                }));
                setServiceOptions(serviceData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllServicesByDepartmentId in DoctorDepartment Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDoctorDepartment = async () => {
        let caughtError;
        try {
            const response = await doctorDepartmentController.GetAllDoctorDepartment(token);
            if (response.status === 200) {
                const docdata = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setDoctorDepartment(docdata);
            }
            else if (response?.data?.status === 400) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctorDepartment",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };


    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Doctor Name", field: "doctorName", width: 250 },
        { headerName: "Doctor Department", field: "departmentName", width: 210 },
        { headerName: "Doctor Sub-department", field: "subDepartmentName", width: 210 },
        { headerName: "Doctor Services", field: "serviceName", width: 210 },
        { headerName: "WEF", field: "wef", width: 210 },
        { headerName: "Doctor Status", field: "departmentStatus", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 170,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            // debugger
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);

                            setDoctorOptions([{
                                doctorName: currentRow.doctorName,
                                doctorId: currentRow.doctorId
                            }]);
                            setDepartmentOptions([{
                                departmentName: currentRow.departmentName,
                                departmentId: currentRow.departmentId
                            }]);
                            setSubDepartmentOptions([{
                                subDepartmentName: currentRow.subDepartmentName,
                                subDepartmentId: currentRow.subDepartmentId
                            }]);
                            setServiceOptions([{
                                serviceName: currentRow.serviceName,
                                serviceId: currentRow.serviceId
                            }]);

                            getAllDoctor();
                            getAllDepartment();
                            // getAllServicesByDepartmentId();

                            handleData();
                        } else {
                            doctorDepartmentController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllDoctorDepartment()
                                        showAlert("success", "Deleted successfully");
                                        setAllDocData((i) => {
                                            return allDocData.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 400) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "DoctorDepartment onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDoctorDepartment = async () => {
        getAllDoctor();
        getAllDepartment();
        // getAllServices();
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        handleData();
    };


    const submitValues = (submitValueData) => {
        debugger
        let submitData = {};
        // tenantId coming from parent/component
        submitData.tenantId = tenantId;
        // Map form fields

        submitData.doctorId = submitValueData?.doctorId;
        submitData.departmentId = submitValueData?.departmentId;
        submitData.subDepartmentId = submitValueData?.subDepartmentId;//doctorSubDepartment
        submitData.serviceId = submitValueData?.serviceId;
        // submitData.wef = submitValueData?.wef;
        // submitData.doctorStatus = submitValueData?.doctorStatus;


        //add for image
        if (requestType === "Edit") {
            // debugger
            submitData.id = submitValueData?.id;
            const id = submitValueData?.id;
            // assuming ID comes from backend
            doctorDepartmentController
                .Update(id, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllDoctorDepartment()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 400)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            doctorDepartmentController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllDoctorDepartment()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 400) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);

    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Doctor Department</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDoctorDepartment()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={doctorDepartment}
                                    fileName={"DoctorDepartment"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Doctor Department"
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, handleChange, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="doctorId"
                                                                value={
                                                                    doctorOptions?.find(
                                                                        (opt) => opt.doctorId === values.doctorId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Doctor <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={doctorOptions || []}
                                                                getOptionLabel={(option) => option?.doctorName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.doctorId === value?.doctorId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("doctorName", value ? value.doctorName : ""); // ✅ only save string
                                                                    setFieldValue("doctorId", value ? value.doctorId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="departmentId"
                                                                value={
                                                                    departmentOptions?.find(
                                                                        (opt) => opt.departmentId === values.departmentId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Department <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={departmentOptions || []}
                                                                getOptionLabel={(option) => option?.departmentName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.departmentId === value?.departmentId}
                                                                onChange={(event, value) => {
                                                                    setSubDepartmentOptions([])
                                                                    setFieldValue("departmentName", value ? value.departmentName : "");
                                                                    setFieldValue("departmentId", value ? value.departmentId : "");
                                                                    getAllServicesByDepartmentId(value.departmentId);
                                                                    getSubDepartment(value.departmentId);
                                                                    setDepartmentId(value.departmentId);
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="subDepartmentId"
                                                                value={
                                                                    subDepartmentOptions?.find(
                                                                        (opt) => opt.subDepartmentId === values.subDepartmentId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Sub-department <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={subDepartmentOptions || []}
                                                                getOptionLabel={(option) => option?.subDepartmentName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.subDepartmentId === value?.subDepartmentId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("subDepartmentName", value ? value.subDepartmentName : ""); // ✅ only save string
                                                                    setFieldValue("subDepartmentId", value ? value.subDepartmentId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="serviceId"
                                                                value={
                                                                    serviceOptions?.find(
                                                                        (opt) => opt.serviceId === values.serviceId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Doctor Service <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={serviceOptions || []}
                                                                getOptionLabel={(option) => option?.serviceName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.serviceId === value?.serviceId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("serviceName", value ? value.serviceName : ""); // ✅ only save string
                                                                    setFieldValue("serviceId", value ? value.serviceId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        {/* <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                label="WEF"
                                                                name="wef"
                                                                type="string"
                                                                value={values.wef || ""}
                                                                onChange={handleChange}
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid> */}
                                                        {/* <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                label="Doctor Status"
                                                                name="doctorStatus"
                                                                type="string"
                                                                value={values.doctorStatus || ""}
                                                                onChange={handleChange}
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid> */}
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box >
        </>
    );
};

export default DoctorDepartment;
